<script>
import VueCharts from 'vue-chartjs'
import $utils from '@/utils/utils'

export default {
    name: 'CampaignStackBarChart',
    extends: VueCharts.Bar,
    props: {
        titleLeft: String,
        data: Object,
        colorBar: String,
        yAxisTicks: Boolean,
        displayLegend: Boolean
    },
    methods: {
        render() {
            let max = Math.max(...this.data.datasets[0].data)
            let maxSize = Math.ceil(max / 5) * 5
            if (this.data.labels.length > 0 && this.data.datasets.length > 0) {
                this.renderChart({
                    labels: this.data.labels,
                    datasets: this.data.datasets
                }, {
                    responsive: true,
                    plugins: {
                        datalabels: {
                            display: false
                        }
                    },
                    legend: {
                        display: this.displayLegend,
                    },
                    scales: {
                        xAxes: [
                            {
                                maxBarThickness: 25,
                                gridLines: {
                                    display: false
                                },
                                ticks: {
                                    fontSize: 14,
                                    fontColor: '#000000'
                                }
                            }
                        ],
                        yAxes: [
                            {
                                maxBarThickness: 25,
                                gridLines: {
                                    display: false
                                },
                                ticks: {
                                    min: 0,
                                    max: maxSize,
                                    display: this.yAxisTicks,
                                    stepSize: Math.ceil(max / 5),
                                    fontSize: 14,
                                    fontColor: '#000000'
                                }
                            }
                        ]
                    },
                    tooltips: {
                        enabled: true,
                        displayColors: false,
                        callbacks: {
                            title: (tooltipItems, data) => {
                                let text = ''
                                this.data.tooltip[tooltipItems[0]['index']].forEach((item, index) => {
                                    if (item.name) {
                                        text += `${index === 0 ? '' : '\n'}` + `${item.name}: ${item.value}`
                                    }
                                })
                                return text.trim()
                            },
                            label: function (tooltipItem, data) {
                                let label = []
                                if (!data.datasets[0]['data_chart']) {
                                    return ''
                                }
                                data.datasets[0]['data_chart'][tooltipItem['index']]['call_time'].forEach((item, index) => {
                                    let dateTime = $utils.convertTimestampToStringFormat(item / 1000, 'HH:mm:ss DD-MM-YYYY')
                                    label.push(`  • ${dateTime}`)
                                })
                                return label
                            },
                            footer: function (tooltipItem, data) {
                                return ''
                            }
                        },
                        backgroundColor: '#000',
                        titleFontSize: 14,
                        titleFontStyle: 'normal',
                        titleFontColor: '#FFF',
                        bodyFontColor: '#FFF',
                        bodyFontSize: 14,
                        xPadding: 12,
                        yPadding: 12
                    },
                    animation: false
                })
            }
        }
    },
    watch: {
        data: {
            deep: true,
            handler: function () {
                this.render()
            }
        }
    }
}
</script>

<style scoped lang="scss">
::v-deep {
    ul.custom-legends {
        border: 1px solid black;
        list-style-type: none;
        padding-left: 0px;

    }

    ul.custom-legends li {
        border: 1px solid lightgray;
        list-style-type: none;
        padding: 5px;
        display: flex;
        align-items: center;
        justify-content: left;
    }

    .dot {
        border-radius: 50px;
        height: 10px;
        width: 10px;
        margin-right: 10px;
    }
}
</style>
